import React, { Component } from "react";
import { message, Tag, Tooltip } from "antd";
import { RobotOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, TableItem } from "../../../Components/Items";
import ModalAccesoIaUsuario from "./ModalAccesoIaUsuario";

class UsuariosIa extends Component {
  state = {
    loading: false,
    usuarios: [],
    totalEmpresas: 0,
    usuarioModal: null,
  };

  componentDidMount() {
    this.consultarUsuarios();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activo && !prevProps.activo) this.consultarUsuarios();
  }

  consultarUsuarios = async () => {
    this.setState({ loading: true });
    try {
      const res = await axios.post("ia/selectUsuariosIa", {}, { headers: this.props.headersToken });
      if (res.data.success === 2) {
        this.setState({ usuarios: res.data.data, totalEmpresas: res.data.totalEmpresas });
      } else {
        message.error(res.data.message || "No se pudieron consultar los usuarios");
      }
    } catch (error) {
      message.error("No se pudieron consultar los usuarios");
    }
    this.setState({ loading: false });
  };

  cerrarModal = (guardado) => {
    this.setState({ usuarioModal: null });
    if (guardado) this.consultarUsuarios();
  };

  render() {
    const columns = [
      {
        title: "Usuario",
        dataIndex: "nombreCompleto",
        key: "nombreCompleto",
        buscar: ["nombreCompleto", "nombreUsuario"],
        render: (value, record) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: "bold" }}>{value}</span>
            <span style={{ fontSize: 12, color: "#888" }}>{record.nombreUsuario}</span>
          </div>
        ),
      },
      {
        title: "Empresas con acceso a IA",
        dataIndex: "empresasConAcceso",
        key: "empresasConAcceso",
        render: (value, record) => (
          <>
            <Tag color={value > 0 ? "cyan" : "default"}>
              {value} de {this.state.totalEmpresas}
            </Tag>
            {record.empresasSinFunciones > 0 && (
              <Tooltip title="Tiene acceso pero ninguna función asignada, así que no puede usar la IA en esas empresas">
                <Tag color="orange">{record.empresasSinFunciones} sin funciones</Tag>
              </Tooltip>
            )}
          </>
        ),
      },
      {
        title: "Acción",
        key: "accion",
        width: 90,
        render: (_, record) => (
          <Tooltip title={"Configurar IA de " + record.nombreCompleto} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            <ButtonItem type="default" size="small" cyan icon={<RobotOutlined />} onClick={() => this.setState({ usuarioModal: record })} />
          </Tooltip>
        ),
      },
    ];

    return (
      <>
        <p style={{ color: "#555" }}>
          Define para cada usuario en qué empresas puede usar la IA y qué funciones tiene. Estos permisos son independientes de los permisos del sistema.
        </p>
        <TableItem size="small" rowKey="_id" dataSource={this.state.usuarios} columns={columns} loading={this.state.loading} pagination={false} />
        <ModalAccesoIaUsuario
          visible={Boolean(this.state.usuarioModal)}
          usuarioId={this.state.usuarioModal?._id}
          usuarioNombre={this.state.usuarioModal?.nombreCompleto}
          onCerrar={this.cerrarModal}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(UsuariosIa);
